import { useTranslation } from "react-i18next";
import { ColumnCustomizerDialog } from "@/components/campaign/ColumnCustomizerDialog";
import {
  CAMPAIGN_TABLE_COLUMNS,
  CAMPAIGN_TABLE_FIXED_COLUMN_IDS,
  CAMPAIGN_TABLE_NON_FIXED_COLUMN_IDS,
  type CampaignTableColumnId,
} from "@/components/campaign/campaign-table-layout";

interface CampaignColumnCustomizerProps {
  visibleNonFixedColumns: readonly CampaignTableColumnId[];
  onApply: (columns: readonly CampaignTableColumnId[]) => void;
}

export function CampaignColumnCustomizer({
  visibleNonFixedColumns,
  onApply,
}: CampaignColumnCustomizerProps) {
  const { t } = useTranslation("campaign");
  return (
    <ColumnCustomizerDialog
      allColumns={CAMPAIGN_TABLE_COLUMNS.map((column) => column.id)}
      fixedColumns={CAMPAIGN_TABLE_FIXED_COLUMN_IDS}
      defaultColumns={CAMPAIGN_TABLE_NON_FIXED_COLUMN_IDS}
      visibleColumns={visibleNonFixedColumns}
      label={(column) => t(`list.table.${column}`)}
      description={t("list.customColumns.description")}
      onApply={onApply}
    />
  );
}
